import React from 'react';
import { ConstructorRequestType } from '../../../Enums/constructors';
import SubrogationInformation from './SubrogationInformation';

const RequestInformation = ({ type, ...props }) => {
  switch (type) {
    case ConstructorRequestType.Subrogation:
      return <SubrogationInformation {...props} />;

    default:
      return <> </>;
  }
};

export default RequestInformation;
